import { ROVVideoStatus } from 'src/enums'
import { IAzureBlobUploadInitDto, IROVVideoCategory, IROVVideoCreate } from 'src/generated-types/rovvideo'

export interface RovVideoFormValues {
  title: string
  description?: string
  category?: IROVVideoCategory | null
  share: boolean
}

export interface RovVideoUploadTargetIds {
  mooringId?: EntityId
  positionId?: EntityId
  mainComponentId?: EntityId
  customerId: EntityId
}

export type CreateBlobVideoPayload = IROVVideoCreate & { customerId: EntityId }

export const buildCreateBlobVideoPayload = (
  formData: RovVideoFormValues,
  initResult: IAzureBlobUploadInitDto,
  screenshotUploadSucceeded: boolean,
  fileSize: number,
  ids: RovVideoUploadTargetIds,
): CreateBlobVideoPayload => ({
  title: formData.title,
  description: formData.description,
  category: formData.category ?? undefined,
  isShared: formData.share,
  mooringId: ids.mooringId as EntityId,
  positionId: ids.positionId as EntityId,
  mainComponentId: ids.mainComponentId as EntityId,
  customerId: ids.customerId,
  azureBlobURL: initResult.blobUrl,
  azureThumbnailURL: screenshotUploadSucceeded ? initResult.screenshotBlobUrl : undefined,
  contentLength: fileSize,
  vimeoId: undefined,
  status: ROVVideoStatus.Available,
})

export type CreateVimeoVideoPayload = IROVVideoCreate & { customerId: EntityId }

export const buildCreateVimeoVideoPayload = (
  formData: RovVideoFormValues,
  vimeoId: string,
  ids: RovVideoUploadTargetIds,
): CreateVimeoVideoPayload => ({
  title: formData.title,
  description: formData.description,
  category: formData.category ?? undefined,
  isShared: formData.share,
  mooringId: ids.mooringId as EntityId,
  positionId: ids.positionId as EntityId,
  mainComponentId: ids.mainComponentId as EntityId,
  customerId: ids.customerId,
  vimeoId,
  status: ROVVideoStatus.Transcoding,
})
